import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import SideNavBar from "../SideNavBar/SideNavBar";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { Box, CircularProgress, Text } from "@chakra-ui/react";
import { use } from "react";
import { getAirTicketingInfo } from "../../../common/allApi";

const SearchList = () => {
  const location = useLocation();
  const storedPnr = sessionStorage.getItem("pnr");
  const myArray = location.state?.myArray || []; // Get the passed array
  const [myArrayList,setmyArrayList]=useState(myArray)
  const pnr = location.state?.pnr || storedPnr || "";



   const handleViewTicket = async (pnr) => {
      // e.preventDefault();
      let sendObj = pnr.trim();
      await getAirTicketingInfo(sendObj)
        .then((res) => {
          if (res?.data?.isSuccess === true) {
            setmyArrayList(res?.data?.data?.searchResult)
          } else {
            toast.error("Data not found!");
          }
        })
        .catch((err) => {});
    };


useEffect(() => {
  if (pnr) {
    handleViewTicket(pnr);
  }
}, [pnr]);

  const getTicketingData = (utid, type, status) => {
    let modifyStatus = status === "Issued" ? "Confirmed" : status;
    if (type === "Booking") {
      window.open(
        "/bookedview?utid=" + utid + "&sts=" + modifyStatus,
        "_blank"
      );
    } else if (type === "Ticket") {
      window.open("/ticket?utid=" + utid + "&sts=" + modifyStatus, "_blank");
    }
  };

  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <div className="content-wrapper search-panel-bg px-4 pb-5">
        <section className="content-header"></section>
        <section className="content">
          <ToastContainer position="bottom-right" autoClose={1500} />
          <div className="mx-lg-5 mx-md-5 mx-sm-1">
            <div className="container-fluid bg-white">
              <Box pt={4}>
                <Text
                  rounded={"sm"}
                  fontSize="15px"
                  fontWeight={700}
                  p={1}
                  mb={2}
                  bg="#5DB3C1"
                  color="white"
                  w="auto"
                  display="inline-block"
                >
                  Search Result For [{pnr}]
                </Text>

                {myArrayList?.length > 0 ? (
                  <div className="table-responsive">
                    <table
                      className="table table-lg"
                      style={{ width: "100%", fontSize: "13px" }}
                    >
                      <thead className="text-start fw-bold bg-secondary">
                        <tr>
                          <th>TYPE </th>
                          <th>STATUS</th>
                          <th>REISSUE</th>
                          <th>REFUND</th>
                          <th>VOID</th>
                          <th>BOOKING ID</th>
                          <th>PNR</th>
                          <th>AIRELINE PNR </th>
                          <th>TICKET NUMBER</th>
                          <th>PAX DETAILS</th>
                          <th>SOURCE</th>
                          <th>BOOKING DATE</th>
                        </tr>
                      </thead>
                      <tbody className="tbody ">
                        {myArrayList?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item?.type}</td>
                              <td>{item.status ==='Issued' ? 'Confirmed' : item.status}</td>
                              <td>{item.isReissued ? 'Yes' : ''}</td>
                              <td>{item.refundStatus}</td>
                              <td>{item.voidStatus}</td>
                              <td
                                onClick={() =>
                                  getTicketingData(
                                    item?.uniqueTransID,
                                    item?.type,
                                    item?.status
                                  )
                                }
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                  cursor: "pointer",
                                }}
                              >
                                {item.uniqueTransID}
                              </td>
                              <td
                                onClick={() =>
                                  getTicketingData(
                                    item?.uniqueTransID,
                                    item?.type,
                                    item?.status
                                  )
                                }
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                  cursor: "pointer",
                                }}
                              >
                                {item.pnr}
                              </td>
                              <td>{item.airlinePNR}</td>
                              <td
                                onClick={() =>
                                  getTicketingData(
                                    item?.uniqueTransID,
                                    item?.type,
                                    item?.status
                                  )
                                }
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                  cursor: "pointer",
                                }}
                              >
                                {item.ticketNumber}
                              </td>
                              <td>{item.passengerName}</td>
                              <td>{item.airline}</td>
                              <td>
                                {" "}
                                {moment(item.createdDate).format(
                                  "DD-MMMM-yyyy"
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="300px"
                    >
                      <Box ml={2}>No data found</Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SearchList;
